import React, {memo, useEffect} from "react";
import {useSelector} from "react-redux";

import {useAppKitAccount, useAppKitNetwork} from "@reown/appkit/react";

import {CHAINS_ENVIRONMENT, CHAINS_MAP, SUPPORTED_CHAINS} from "utils";
import { CHAIN_TO_PARAMS_MAP} from "web3/chains";
import {useBalance} from "hooks";

import {Switch} from "components/atoms";

const SwitchBlock = () => {
    const {getBalanceAndSave, getKMTBalanceAndSave} = useBalance()

    const {chainId, switchNetwork} = useAppKitNetwork()
    const {isConnected} = useAppKitAccount();

    const {userData} = useSelector(state => state.authV2.signIn)

    const supportedChains = CHAINS_MAP[CHAINS_ENVIRONMENT]

    useEffect(() => {
        chainCheck()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [chainId])

    const switchNetworkHandler = (checked) => {
        const currentChainId = checked ? supportedChains.BASE : supportedChains.ETH
        const {appKitNetwork} = CHAIN_TO_PARAMS_MAP[currentChainId]

        switchNetwork(appKitNetwork)
    }

    const chainCheck = () => {
        if (chainId && SUPPORTED_CHAINS[CHAINS_ENVIRONMENT].includes(chainId)) {
            if (userData?.wallet) {
                getBalanceAndSave(chainId, userData.wallet)
                getKMTBalanceAndSave(chainId, userData.wallet)
            }
        }
    }

    return (
        <div className="navigation_auth_user-details_panel_switch-block">
            <span className="navigation_auth_user-details_panel_switch-block_chain-name">
                {chainId === supportedChains.BASE ? "Base" : "Eth"}
            </span>
            <Switch
                disabled={!isConnected}
                checked={chainId === supportedChains.BASE}
                onChange={() => switchNetworkHandler(!(chainId === supportedChains.BASE))}
            />
        </div>
    )
}

export default memo(SwitchBlock)